<template>
  <SummaryPanel title="Fuel & Efficiency" :badges="badges" :anchor-id="anchorId">
    <div class="panel-table-scroll">
      <table class="table panel-table efficiency-table">
        <thead class="thead-light">
          <tr>
            <th>Metric</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in model.rows" :key="row.key">
            <td>{{ row.label }}</td>
            <td>{{ formatValue(row) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </SummaryPanel>
</template>

<script>
import { formatNum } from '@/util/number';
import SummaryPanel from './SummaryPanel.vue';

export default {
  name: 'EfficiencyPanel',
  components: {
    SummaryPanel,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
  methods: {
    formatValue(row) {
      return row.value === null ? 'N/A' : `${formatNum(row.value, 2)} ${row.unit}`;
    },
  },
};
</script>

<style src="./summaryPanel.css"></style>

<style scoped>
/* label panjang boleh turun baris di HP, angka tetap utuh */
.efficiency-table td:first-child {
  white-space: normal;
}
</style>
